import React, { useState, useEffect } from "react";
import "./ErrorNotification.css";
import { useTranslation } from "react-i18next";

const ErrorNotification = ({ errors, width, marginBottom, marginLeft }) => {
  const [showErrors, setShowErrors] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Check if errors object has any error messages
    const hasErrors =
      errors &&
      Object.keys(errors).length > 0 &&
      Object.values(errors).some((error) => error && error.trim() !== "");

    setShowErrors(hasErrors);
  }, [errors]);

  if (!showErrors) return null;

  const containerStyle = {
    width: width || "auto",
    ...(marginLeft !== undefined && { marginLeft }),
    ...(marginBottom !== undefined && { marginBottom }),
  };

  return (
    <div className="error-notification-container" style={containerStyle}>
      <div className="error-list">
        {Object.entries(errors).map(([field, message]) => {
          // Only show non-empty error messages
          if (!message || message.trim() === "") return null;

          // Remove trailing numbers (e.g. "_0") so "location_0" becomes "location" before translation
          const cleanField = field.replace(/_\d+$/, "");

          return (
            <div key={field} className="error-item ">
              <span className="error-field-name ">
                {t(
                  cleanField
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase())
                    .replace(/^(Mobile|Phone)$/, "$1 Number")
                    .replace("Income Expense Type", "Income/Expense Type"),
                )}
                :
              </span>{" "}
              <span className="error-message">{t(message)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ErrorNotification;
